<template>
  <div class="row" style="margin-top: 10px;">
    <div class="col-md-12 col-sm-12">
      <h2 class="title_selecciona">Búsqueda de experiencias en adaptación en el mapa</h2>
      <h4
        class="sub_title_selecciona"
        style="line-height: initial;width: 50%;"
      >Si desea una búsqueda por municipio selecciona el departamento en el mapa</h4>
    </div>
    <div class="col-md-5 col-sm-12">
      <Colombia v-on:map-clicked="onMapClick"></Colombia>
    </div>
    <div class="col-md-7 col-sm-12">
      <p>Comparte tu experiencia</p>
      <div class="row">
        <div class="col-md-7 col-sm-12"></div>
      </div>
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <a href="#/experiencias">
            <img
              src="test2.jpg"
              alt="desarrollo_agroclimatico"
              class="img-fluid img_body_create_experience"
            />
            <p
              style="font-size: 30px; position: absolute; margin-top: -65px; right: 25px; color: #fff"
            >Crear Experiencia Adaptación</p>
          </a>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-sm-12">
        <h2 class="title_selecciona">
          Sector
          agropecuario bajo en carbono
        </h2>
        <h4 class="sub_title_selecciona" style="line-height: initial;width: 50%;">
           <a href="#/mitigacion" style="color:#138d6a;">Consulte información de la mitigación de los gases de efecto invernadero en los sectores agrícola y pecuario</a>
        </h4>
      </div>
    </div>
      <div class="row">
        <div class="col-md-6 col-sm-12">
          <a href="#/mitigacion">
            <img
              src="clima-min.jpg"
              alt="desarrollo_agroclimatico"
              class="img-fluid img_body_create_experience"
            />
            <p
              style="font-size: 30px; position: absolute; margin-top: -65px; right: 25px; color: #fff"
            >Consultar información</p>
          </a>
        </div>
         <div class="col-md-6 col-sm-12">
          <a href="#/boletines">
            <img
              src="boletin-min.jpg"
              alt="desarrollo_agroclimatico"
              class="img-fluid img_body_create_experience"
            />
            <p
              style="font-size: 30px; position: absolute; margin-top: -65px; right: 25px; color: #fff"
            >Boletines Agroclimáticos</p>
          </a>
        </div>
      </div>
  </div>
</template>


<script>
import Colombia from "../ColombianMap";

import axios from "axios";

export default {
  components: {
    Colombia
  },
  data() {
    return {};
  },
  methods: {
    onMapClick: function(attr) {
      console.log({
        group: "map",
        title: "State clicked",
        text: `You clicked on state with id: ${attr.mapId} and title: ${attr.title}`
      });
    },
    goView: function(attr) {
      console.log("god")
    }

  },
  computed: {}
};
</script>


<style>
.select_municipios {
  margin-top: 10px;
}
.title_selecciona {
  color: #3366cc;
  font-weight: bolder;
  margin-top: 10px;
}
.sub_title_selecciona {
  color: #138d6a;
  line-height: 0;
  font-weight: 100 !important;
}
.img_body_create_experience {
  width: 100%;
  height: 200px !important;
  margin-bottom: 20px;
  margin-top: 20px;
  object-fit: cover;
}
</style>
